import { useState, useEffect } from 'react';
import HeaderLogo from "./HeaderLogo";

export const Navigation = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // If switching to desktop, ensure menu is visible
      if (!mobile) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav id="menu" className="navbar navbar-default">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <HeaderLogo />
        </div>

        <div
          className="navbar-collapse"
          style={{ display: !isMobile || isOpen ? 'block' : 'none' }}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll" onClick={() => setIsOpen(false)}>
                Features
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll" onClick={() => setIsOpen(false)}>
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll" onClick={() => setIsOpen(false)}>
                Services
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={() => setIsOpen(false)}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};